import { FormsFieldPreset, AdiFieldPreset } from '@wix/forms-common'
import { FirstName } from '../../recommended-fields/definitions/first-name'

export class AdiFirstName extends FirstName {
  public get fieldType() {
    return AdiFieldPreset.ADI_FIRST_NAME
  }

  public get mainCrmTypes() {
    return []
  }

  protected get data() {
    return {
      textType: 'text',
      placeholder: this.translate(`adi.fieldTypes.${FormsFieldPreset.FIRST_NAME}.placeholder`),
      label: this.translate(`adi.fieldTypes.${FormsFieldPreset.FIRST_NAME}.label`),
    }
  }

  protected get props(): any {
    return {
      required: true,
    }
  }

  protected get ADI_titleTranslationKey() {
    return `adi.${FormsFieldPreset.FIRST_NAME}FieldEditPanel.title`
  }

  public get allowOnlyOnce() {
    return true
  }

  protected get crmLabel() {
    return this.translate(`fieldTypes.${FormsFieldPreset.FIRST_NAME}`)
  }
}
